function tablePopups(elem, land, data) {

    var tablecontainer = document.createElement('div');
    tablecontainer.className = 'tablecontainer';

    var table = document.createElement('table');
    table.className = 'tabel_opgemaakt';

    var thead = document.createElement('thead');
    var tr = document.createElement('tr');

    var th1 = document.createElement('th');
    th1.textContent = 'Destination';
    tr.appendChild(th1);

    var th2 = document.createElement('th');
    th2.textContent = 'Time by train';
    tr.appendChild(th2);

    var th3 = document.createElement('th');
    th3.textContent = 'Transfers';
    tr.appendChild(th3);

    var th4 = document.createElement('th');
    th4.innerHTML = '<span class="co2"</span>CO';
    th4.innerHTML += ' emission (train)';
    tr.appendChild(th4);

    var th5 = document.createElement('th');
    th5.textContent = 'Time by plane';
    tr.appendChild(th5);

    var th6 = document.createElement('th');
    th6.innerHTML = '<span class="co2"</span>CO';
    th6.innerHTML += ' emission (plane)';
    tr.appendChild(th6);

    thead.appendChild(tr);
    table.appendChild(thead);

    var tbody = document.createElement('tbody');


    



    resultaat = finddestination(data, land)

    resultaat.forEach(function(row) {

            // nachttrein
            var maan_container = document.createElement('div');
            maan_container.classList.add('tableicon');
            var maan = document.createElement('img');
            maan.src = "./img/moon.svg";
            maan_container.appendChild(maan);

            // bus
            var bus_container = document.createElement('div');
            bus_container.classList.add('tableicon');
            var bus = document.createElement('img');
            bus.src = "./img/tram.svg";
            bus_container.appendChild(bus);

        var tabel_body = document.createElement('tr');

        var country = document.createElement('td');
            country.id = 'country';
            country.textContent = row.destination;
            tabel_body.appendChild(country);
    
        var train_time = document.createElement('td');
            train_time.id = 'train_time';


            if (row['treintijd_uren'] == '0') {
                train_time.textContent = '--';
            } else {
                train_time.textContent = row['treintijd_uren'] + "h " + row['treintijd_minuten'] + "m";
            }

            if (row['nachttrein'] == 1) {
                train_time.appendChild(maan_container);
            }
            tabel_body.appendChild(train_time);
    
        var transfers = document.createElement('td');
            transfers.id = 'transfers';
            transfers.textContent = row['overstappen'];
            tabel_body.appendChild(transfers);
    
        var emission_train = document.createElement('td');
            emission_train.id = 'emission_train';
            emission_train.textContent = row['co2_trein'] + "kg";
            tabel_body.appendChild(emission_train);
    
        var plane = document.createElement('td');
            plane.id = 'plane';


            if (row['vluchttijd_uren'] == '0') {
                plane.textContent = '--';
            } else {
                plane.textContent = row['vluchttijd_uren'] + "h " + row['vluchttijd_minuten'] + "m";
            }

            tabel_body.appendChild(plane);
            if (row['comments'] !== null && row['comments'] !== undefined && row['comments'] !== '') {
                plane.appendChild(bus_container);
            }
    
        var emission = document.createElement('td');
            emission.id = 'emission';

            if (row['co2_vlucht'] == '0') {
                emission.textContent = '--';
            } else {
                emission.textContent = row['co2_vlucht'] + "kg";
            }

            tabel_body.appendChild(emission);
    
        tbody.appendChild(tabel_body);

        tabel_body.addEventListener('click', (event) => {
            showPopup(country.textContent);
        });
    });




    table.appendChild(tbody);

    tablecontainer.appendChild(table);

    elem.appendChild(tablecontainer);
    

}


